import { render, staticRenderFns } from "./applicationRecord.vue?vue&type=template&id=cfc52670&scoped=true&"
import script from "./applicationRecord.vue?vue&type=script&lang=js&"
export * from "./applicationRecord.vue?vue&type=script&lang=js&"
import style0 from "./applicationRecord.vue?vue&type=style&index=0&id=cfc52670&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc52670",
  null
  
)

export default component.exports